import { pdfStore, usePdfViewerStore } from "@/slices/pdfViewer";
import { cn } from "@/utils/helper";
import { useEffect, useRef } from "react";

/**
 * @param {{page:import("pdfjs-dist").PDFPageProxy}} param0
 */
export default function ThumbnailRender({ page }) {
  const canvasRef = useRef(null);
  const pdfViewer = pdfStore.getState().pdfViewer;
  const currentPage = usePdfViewerStore((state) => state.page);

  const onThumbClick = () => {
    if (pdfViewer) {
      pdfViewer.currentPageNumber = page.pageNumber;
    }
  };

  const canvasRefCallback = (node) => {
    if (node != null) {
      canvasRef.current = node;
      if (currentPage === page.pageNumber) {
        node.scrollIntoView();
      }
    }
  };

  useEffect(() => {
    async function renderThumb() {
      const canvas = canvasRef.current;
      let viewport = page.getViewport({ scale: 1.0 });

      const context = canvas.getContext("2d");

      const { width, height } = viewport;
      const ratio = width / height;
      canvas.width = 98;
      canvas.height = (98 / ratio) | 0;
      const scale = 98 / width;
      viewport = page.getViewport({ scale });

      await page.render({
        canvasContext: context,
        viewport: viewport,
      }).promise;
    }
    if (canvasRef.current != null) {
      renderThumb();
    }
  }, [page]);

  return (
    <div
      onClick={onThumbClick}
      className={cn(
        "hover:border-primary flex cursor-pointer items-center justify-center rounded-md border p-4 hover:border-solid",
        {
          "border-primary border-solid": currentPage === page.pageNumber,
        }
      )}
    >
      <canvas
        className="rounded-md border border-solid border-gray-200 shadow-md"
        ref={canvasRefCallback}
      />
    </div>
  );
}
